import React from "react";
import Head from "next/head";

const HeadTag = ({ title, description, data }) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description}></meta>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
      <meta name="robots" content="index, follow" />
      <link rel="icon" href="/favicon.ico" />
      {data?.canonical && <link rel="canonical" href={data.canonical} />}
      {data?.prevPage && <link rel="prev" href={data.prevPage} />}
      {data?.nextPage && <link rel="next" href={data.nextPage} />}
      <meta
        name="google-site-verification"
        content="SDoYGm6p7NT4jEVFqpVeCAgWnt0xzh6o3HLQNLhWBtA"
      />
      {data && (
        <>
          <meta property="og:url" content={data?.canonical} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={data.title} />
          <meta property="og:description" content={data.description} />
          <meta
            property="og:image"
            content={process.env.NEXT_PUBLIC_CDN + "/uploads/" + data.resim}
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:domain"
            content={process.env.NEXT_PUBLIC_DOMAIN}
          />
          <meta property="twitter:url" content={data.canonical} />
          <meta name="twitter:title" content={data.title} />
          <meta name="twitter:description" content={data.description} />
          <meta
            name="twitter:image"
            content={process.env.NEXT_PUBLIC_CDN + "/uploads/" + data.resim}
          />
        </>
      )}
    </Head>
  );
};

export default HeadTag;
